import { Grid, Typography } from "@mui/material";
import DividerCustom from "../components/DividerFund";
import { FormProvider } from "react-hook-form";
import { BtnBack, BtnSave } from "components/Button/ButtonAll";
import { TextAreaItem } from "components/Input/TextArea";
import { DefaultArrayEmpty, Extension, I18n, ParseHtml } from "utilities/utilities";
import UploadFile from "components/Input/UploadFile";
import {
  useActivityGrid,
  useActivityOtherGrid,
  useFollowUpReview,
} from "../hooks/useFollowUp";
import DataGrid from "components/DataGrid";
import { CheckBoxItem } from "components/Input/Checkbox/CheckBoxItem";
import { useLocation } from "react-router";

const FollowUpApprove = () => {
  const location = useLocation();
  const searchParams = location.search;
  const sActivityID = new URLSearchParams(searchParams).get("sActivityID");

  const {
    form,
    dataRow,
    arrFileActivityList,
    setArrFileActivityList,
    onClearFile,
    onClearFileClose,
    handleChangeOther,
    formOther,
    dataRowOther,
    isClose,
    isReport,
    handleChangeClose,
    arrFileCloseActivityList,
    setArrFileCloseActivityList,
    objData,
    handleEdit,
    handleDelete,
    handleEditOther,
    handleDeleteOther,
    onBackApprove,
    handleSubmitApproved,
    sTextSubmit,
    isPermission,
    isOther
  } = useFollowUpReview(sActivityID, true);
  const dataColumn = useActivityGrid(handleEdit, handleDelete, true);
  const dataOtherColumn = useActivityOtherGrid(handleEditOther, handleDeleteOther, true);
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography
          sx={{
            fontSize: "1.25rem",
            fontWeight: 500,
            color: "#1256bc",
            textAlign: "center",
          }}
        >
          การรายงานผลปฎิบัติการ
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={3.5}>
            <Typography className="font-medium">วิสัยทัศน์</Typography>
          </Grid>
          <Grid item xs={12} md={8.5}>
            <Typography>{objData.sVision}</Typography>
          </Grid>
          <Grid item xs={12} md={3.5}>
            <Typography className="font-medium">พันธกิจ</Typography>
          </Grid>
          <Grid item xs={12} md={8.5}>
            <Typography>{objData.sMission}</Typography>
          </Grid>
          <Grid item xs={12} md={3.5}>
            <Typography className="font-medium">เป้าประสงค์</Typography>
          </Grid>
          <Grid item xs={12} md={8.5}>
            <Typography>{ParseHtml(objData.sGoal)}</Typography>
          </Grid>
          <Grid item xs={12} md={3.5}>
            <Typography className="font-medium">ยุทธศาสตร์ที่ {objData.sOrderStrategic}</Typography>
          </Grid>
          <Grid item xs={12} md={8.5}>
            <Typography>{objData.sStrategic}</Typography>
          </Grid>
          <Grid item xs={12} md={3.5}>
            <Typography className="font-medium">
              เป้าประสงค์เชิงยุทธศาสตร์
            </Typography>
          </Grid>
          <Grid item xs={12} md={8.5}>
            <Typography>{ParseHtml(objData.sTarget)}</Typography>
          </Grid>
          <Grid item xs={12} md={3.5}>
            <Typography className="font-medium">กลยุทธ์ที่ {objData.sOrderStrategy}</Typography>
          </Grid>
          <Grid item xs={12} md={8.5}>
            <Typography>{objData.sStrategy}</Typography>
          </Grid>
          <Grid item xs={12} md={3.5}>
            <Typography className="font-medium">โครงการ</Typography>
          </Grid>
          <Grid item xs={12} md={8.5}>
            <Typography>{objData.sProject}</Typography>
          </Grid>
          <Grid item xs={12} md={3.5}>
            <Typography className="font-medium">กิจกรรม</Typography>
          </Grid>
          <Grid item xs={12} md={8.5}>
            <Typography>{objData.sActivity}</Typography>
          </Grid>
          <Grid item xs={12} md={3.5}>
            <Typography className="font-medium">อยู่ภายใต้กิจกรรม</Typography>
          </Grid>
          <Grid item xs={12} md={8.5}>
            {DefaultArrayEmpty(objData.lstSubActivity).map((activity) => (
              <Typography key={"sub_" + activity}>{ParseHtml(activity)}</Typography>
            ))}
          </Grid>
          <Grid item xs={12} md={3.5}>
            <Typography className="font-medium">
              {I18n.SetText("FundPlan.Duration")}
            </Typography>
          </Grid>
          <Grid item xs={12} md={8.5}>
            <Typography>{objData.sDuration}</Typography>
          </Grid>
          <Grid item xs={12} md={3.5}>
            <Typography className="font-medium">
              อ้างอิงตัวชี้วัด (กรมบัญชีกลาง)
            </Typography>
          </Grid>
          <Grid item xs={12} md={8.5}>
            <Typography>{ParseHtml(objData.sIndicator)}</Typography>
          </Grid>
          <Grid item xs={12} md={3.5}>
            <Typography className="font-medium">ค่าน้ำหนักกิจกรรม</Typography>
          </Grid>
          <Grid item xs={12} md={8.5}>
            <Typography>{objData.sWeight}</Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Typography
          sx={{
            fontSize: "1.25rem",
            fontWeight: 500,
            color: "#4992ff",
          }}
        >
          การรายงานผล
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <FormProvider {...form}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <DividerCustom txt="รายงานผลกิจกรรม" className="divider-chip" />
            </Grid>
            <Grid item xs={12}>
              <DataGrid
                sTableID="tableFollowUpReview"
                columns={dataColumn}
                rows={dataRow}
                modeFilter={0}
                isLoading={false}
                onLoadData={(e) => { }}
                isShowCheckBox={false}
                isHiddenToolHead
              />
            </Grid>
            <Grid item xs={12}></Grid>
            <Grid item xs={12}>
              <Typography className="font-medium">หลักฐาน/เอกสารแนบ</Typography>
            </Grid>
            <Grid item xs={12}>
              <UploadFile
                id="sDocFile_Activity"
                name={"arrActivityFile"}
                key={"sDocFile_Activity"}
                IsDrag={true}
                arrFile={arrFileActivityList}
                setarrFile={setArrFileActivityList}
                IsFolder={false}
                IsMultiple={true}
                Extension={[...Extension.FileTicket, ...Extension.Word]}
                nLimitFile={30}
                sLimitFile={"MB"}
                onClearFile={onClearFile}
                modeDisplay={"table"}
                sFolderTemp={"FundWork"}
                IsDragDrop={false}
                IsCrop={false}
                sPositionText={"right"}
                required={true}
                disabled={!isPermission}
                IsCanDel={false}
                IsHide={true}
              />
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={2} padding={"0 3rem"}>
                <Grid item xs={12}>
                  <DividerCustom txt="ปิดกิจกรรม" className="divider-chip-close" />
                </Grid>

                <Grid item xs={12}>
                  <CheckBoxItem
                    name="isCloseActivity"
                    options={[
                      {
                        value: "true",
                        label: "ปิดกิจกรรม",
                      },
                    ]}
                    onChange={(e) => handleChangeClose(e)}
                    disabled={!isPermission}
                  />
                </Grid>

                {isClose && (
                  <Grid item xs={12}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextAreaItem
                          name="sReason"
                          label="เหตุผลในการปิดกิจกรรม"
                          required
                          maxLength={250}
                          IsShowTextCont
                          disabled={!isPermission}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography className="font-medium">
                          หลักฐาน/เอกสารแนบ
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <UploadFile
                          id="sDocFile_CloseActivity"
                          name={"arrCloseActivityFile"}
                          key={"sDocFile_CloseActivity"}
                          IsDrag={true}
                          arrFile={arrFileCloseActivityList}
                          setarrFile={setArrFileCloseActivityList}
                          IsFolder={false}
                          IsMultiple={true}
                          Extension={[...Extension.FileTicket, ...Extension.Word]}
                          nLimitFile={30}
                          sLimitFile={"MB"}
                          onClearFile={onClearFileClose}
                          modeDisplay={"list"}
                          sFolderTemp={"FundWork"}
                          IsDragDrop={false}
                          IsCrop={false}
                          sPositionText={"right"}
                          required={true}
                          disabled={!isPermission}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
        </FormProvider>
      </Grid>
      <Grid item xs={12}></Grid>
      <Grid item xs={12}>
        <DividerCustom txt="การปฎิบัติงานเพิ่มเติมนอกเหนือเเผน" className="divider-chip" />
      </Grid>
      <FormProvider {...formOther}>
        <Grid item xs={12}>
          <CheckBoxItem
            name="isOther"
            options={[
              {
                value: "true",
                label: "การปฎิบัติงานเพิ่มเติมนอกเหนือเเผน (ถ้ามี)",
              },
            ]}
            onChange={(e) => handleChangeOther(e)}
            disabled
          />
        </Grid>
        {isOther &&
          <Grid item xs={12}>
            <DataGrid
              sTableID="tableActivityOther"
              columns={dataOtherColumn}
              rows={dataRowOther}
              modeFilter={0}
              isLoading={false}
              onLoadData={(e) => { }}
              isShowCheckBox={false}
              onDelete={() => { }}
              isHiddenToolHead
            />
          </Grid>
        }
      </FormProvider>
      {/* button action */}
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <BtnBack
              id="back"
              onClick={onBackApprove}
            />
          </Grid>
          {
            (isPermission && (isReport || isClose)) && (
              <Grid item xs={6}>
                <Grid container display={"flex"} justifyContent={"flex-end"} spacing={1} >
                  <Grid item>
                    <BtnSave
                      id="save"
                      txt={sTextSubmit}
                      onClick={form.handleSubmit(() => {
                        handleSubmitApproved();
                      }, (err) => {
                        console.log("err", err)
                      })}
                    />
                  </Grid>
                </Grid>
              </Grid>
            )
          }
        </Grid>
      </Grid>
    </Grid >
  );
};

export default FollowUpApprove;
